import { render, staticRenderFns } from "./deductionList-negative.vue?vue&type=template&id=d7c7e7bc&scoped=true"
import script from "./deductionList-negative.vue?vue&type=script&lang=js"
export * from "./deductionList-negative.vue?vue&type=script&lang=js"
import style0 from "./deductionList-negative.vue?vue&type=style&index=0&id=d7c7e7bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c7e7bc",
  null
  
)

export default component.exports